import StreetRequest from 'jsgeo/lib/request/street.js';

StreetRequest.url = '/location/map';

class Streets {
    prepareRequest(data = {}) {
        return new StreetRequest(data);
    }

    get(data = {}) {
        var request = this.prepareRequest(data);

        return request.make();
    }
}

export default new Streets();
